var $ = jQuery;

import { carousel } from '../lib/carousel.js';

// Benefit cards on the travel pages. All seven fit side by side from 1600px,
// at the card width they had before; below that the arrows reach the rest.
$(document).on('ready', function(){
    $('.benefits-swiper').each(function(){
      carousel(this, this.parentElement, {
        label: 'benefit',
        slidesPerView: 1.6,
        spaceBetween: 16,
        breakpoints: {
          640: { slidesPerView: 2.5, spaceBetween: 20 },
          1024: { slidesPerView: 4, spaceBetween: 20 },
          1280: { slidesPerView: 5, spaceBetween: 20 },
          1600: { slidesPerView: 7, spaceBetween: 20 },
        },
      });
    });
  });
